import { useQuery } from '@tanstack/react-query'
import { api } from '@astro/api'
import { unwrapGalleryList, unwrapGalleryItem } from '../components/sections/gallery/galleryData'

const PER_PAGE = 12

/** GET /gallery — paginated list, loaded a page at a time and accumulated
 * for a "load more" masonry grid. */
export function useGalleryList(page = 1) {
  const query = useQuery({
    queryKey: ['gallery-list', page, PER_PAGE],
    queryFn: () => api.gallery.list({ page, per_page: PER_PAGE }),
    placeholderData: (prev) => prev,
    select: unwrapGalleryList,
  })
  return {
    items: query.data?.items ?? [],
    currentPage: query.data?.currentPage ?? 1,
    lastPage: query.data?.lastPage ?? 1,
    total: query.data?.total ?? 0,
    isPending: query.isPending,
    isFetching: query.isFetching,
    isError: query.isError,
    refetch: query.refetch,
  }
}

/** GET /gallery/{id} — full album detail (every image/video), used to enrich the album viewer modal. */
export function useGalleryItem(id) {
  const query = useQuery({
    queryKey: ['gallery-item', id],
    queryFn: () => api.gallery.get(id),
    enabled: id != null,
    select: unwrapGalleryItem,
  })
  return {
    item: query.data ?? null,
    isPending: query.isPending,
    isError: query.isError,
  }
}
